import { useDispatch, useSelector } from 'react-redux'
import { DeserveModalInterface } from '../../../Interfaces/DeserveModalInterface'
import { RaytebRequests } from '../../../_services'
import { ErrorTypeEnum, Message } from '../../../_services/ResponseErrorType'
import useFetch from '../../../_services/fetch'
import { GenderEnum } from '../../../enums/GenderEnum'
import { Button, Icon, RaytebForm, TextBox } from '../../Elements'
import Avatar from '../ImageAvatars/Avatar'
import RaytebModal from './RaytebModal'
import React, { useEffect, useState } from 'react'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import LoadingFit from '../Loading/LoadingFit'
import { addOrUpdatePrescription } from '../../../storeManager/Reducers/prescriptionSlice'
import { PrescriptionViewModel } from '../../../models/ViewModels/PrescriptionViewModel'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { toast } from 'react-toastify'

const DeserveModal: React.FC<DeserveModalInterface> = ({
  data,
  isOpen,
  hideModal,
  onAdded,
  showFooter,
  doctorServeShift,
}) => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const dispatch = useDispatch()
  const [printCodeReferral, setPrintCodeReferral] = useState<number | null>(
    null
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )

  const [mobile, setMobile] = useState<string>(data?.mobile!);
  const { isLoading, reFetch } = useFetch<PrescriptionViewModel, Object>({
    request: RaytebRequests.Appointment_DeserveConfirm_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(res) {
      // dispatch(
      //   addOrUpdatePrescription({
      //     ...res,
      //     isReferenceable: data?.isReferenceable,
      //   })
      // )
      onAdded?.(res, doctorServeShift)
    },
  })

  const [isEditMobile, setEditMobile] = useState<boolean>(false)
  const changeMobileRequest = useFetch<Array<Message>, ChnageMobileInputModel>({
    request: RaytebRequests.Patient_ChnageMobile_POST({
      centerId: center.id,
      token: user?.token,
    }),
    onSuccess(data) {
      data.forEach((n) => {
        if (n.flag === ErrorTypeEnum.Error) toast.error(n.message)
        else if (n.flag === ErrorTypeEnum.Info) toast.info(n.message)
        else if (n.flag === ErrorTypeEnum.Warning) toast.warn(n.message)
        else toast.info(n.message)
      })
      setMobile(changeMobileRequest.payLoad?.phoneNumber!)
      setEditMobile(false)
    },
  })
  useEffect(() => {
    setMobile(data?.mobile!);
  }, [data?.mobile])
  return (
    <RaytebModal
      isOpen={isOpen}
      hideModal={() => hideModal?.()}
      title='اطلاعات بیمار'
      className={
        '!shadow-inner xs:min-w-[96%] relative max-h-screen overflow-y-auto'
      }
    >
      <LoadingFit isLoading={isLoading || changeMobileRequest.isLoading} />
      <div className='w-full max-w-sm  rounded-lg px-2 mx-auto'>
        <div className='flex flex-col items-center '>
          <Avatar
            className='!w-24 !h-24 !text-4xl !mb-3 !rounded-full !p-1 !shadow-inner !shadow-disable'
            url={data?.imageUrl}
          />
          <h5 className='mb-1 text-sm font-extrabold '>{`${data?.firstName} ${data?.lastName}`}</h5>
          <span className='text-sm text-gray-500 '>{data?.code}</span>
          {data?.isReferenceable && showFooter ? (
            <div className='mt-5 flex flex-col gap-2 justify-center items-center'>
              <div>
                <TextBox
                  innerText='کد رهگیری'
                  Type={TextBoxTypeEnum.PrintCode}
                  className='!w-24'
                  onChange={(e) => setPrintCodeReferral(e.target.value)}
                />
              </div>
              <span className='text-[11px] text-primary font-bold'>
                <span className='text-danger text-sm'>*</span>{' '}
                {`پزشک محترم ، بیمار از مسیر ارجاع وارد شده ، لطفا کد رهگیری نسخه ثبت شده توسط پزشک 
                   خانواده بیمار را وارد کنید`}
              </span>
            </div>
          ) : (
            ''
          )}

          <div className='grid grid-cols-3   mt-10 w-full gap-x-2 gap-y-6 '>
            {data?.insuranceTypeTitle ? (
              <DetailInfo title={'بیمه'} value={data?.insuranceTypeTitle} />
            ) : (
              ''
            )}
            {data?.mobile ? (
              <RaytebForm
                checkIsRequired={true}
                onSubmit={(e) => {
                  changeMobileRequest.reFetch({
                    patientCode: data.code!,
                    phoneNumber: e.target['Mobile'].value,
                  })
                }}
              >
                <DetailInfo
                  title={'موبایل'}
                  value={mobile}
                  isEdit={true}
                  className='h-full'
                  onShow={() => setEditMobile(true)}
                  onClose={() => setEditMobile(false)}
                  isOpen={isEditMobile}
                  editOption={{
                    innerText: 'تغییر شماره همراه',
                    Type: TextBoxTypeEnum.Mobile,
                    isLtR: false,
                    isRequired: true,
                    name: 'Mobile',
                    onClick: (e) => {
                      e.target.select()
                    },
                  }}
                />
              </RaytebForm>
            ) : (
              ''
            )}
            {data?.age ? <DetailInfo title={'سن'} value={data?.age} /> : ''}
            {data?.insuranceBoxTitle ? (
              <DetailInfo
                title={'صندوق بیمه'}
                value={data?.insuranceBoxTitle}
              />
            ) : (
              ''
            )}
            {data?.insuranceExpirationDate ? (
              <DetailInfo
                title={'تاریخ انقضا'}
                value={new Date(data?.insuranceExpirationDate).toShamsi()}
              />
            ) : (
              ''
            )}
            {data?.gender ? (
              <DetailInfo title={'جنسیت'} value={GenderEnum[data?.gender]} />
            ) : (
              ''
            )}
          </div>
          <div className='grid grid-cols-3  items-center mt-4 w-full gap-x-4 gap-y-6  py-3'>
            {data?.servePrice?.insureShare != null ? (
              <DetailInfo
                className='!border-warnDark'
                title={'سهم سازمان'}
                value={data?.servePrice?.insureShare}
              />
            ) : (
              ''
            )}
            {data?.servePrice?.patientShare != null ? (
              <DetailInfo
                className='!border-warnDark'
                title={'سهم بیمار'}
                value={data?.servePrice?.patientShare}
              />
            ) : (
              ''
            )}
            {data?.servePrice?.total != null ? (
              <DetailInfo
                className='!border-warnDark'
                title={'کل'}
                value={data?.servePrice?.total}
              />
            ) : (
              ''
            )}
          </div>
          <div>
            {data?.servePrice?.messages?.map((n, i) => (
              <div key={i}>
                {n.flag === ErrorTypeEnum.Error ? (
                  <span className='text-danger text-[11px]'>{n.message}</span>
                ) : n.flag === ErrorTypeEnum.Warning ? (
                  <span className='text-warn text-[11px]'>{n.message}</span>
                ) : n.flag === ErrorTypeEnum.Info ? (
                  <span className='text-warn text-[11px]'>{n.message}</span>
                ) : (
                  n.message
                )}
              </div>
            ))}
          </div>
        </div>
        {showFooter ? (
          <div className='flex justify-center items-center px-6 gap-10 w-full py-3 sticky top-full'>
            <Button
              onClick={() => hideModal?.()}
              className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              انصراف
            </Button>
            <Button
              className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
              type='submit'
              onClick={() => {
                if (data?.isReferenceable && !printCodeReferral) {
                  if (
                    !window.confirm(
                      'کد رهگیری پزشک خانواده بیمار خالی میباشد آیا مطمئن هستید ویزیت  خارج از مسیر ارجاع ثبت شود ؟'
                    )
                  ) {
                    return
                  }
                }

                reFetch({
                  patientCode: data?.code,
                  doctorServeShift: doctorServeShift,
                  printCodeReferral: printCodeReferral,
                })
              }}
            >
              ثبت نوبت
            </Button>
          </div>
        ) : (
          ''
        )}
      </div>
    </RaytebModal>
  )
}

const DetailInfo = ({
  title,
  value,
  className,
  isEdit,
  editOption,
  isOpen,
  onClose,
  onShow,
}: {
  title: string
  value: any
  className?: string
  isEdit?: boolean
  editOption?: TextBoxInterface
  isOpen?: boolean
  onClose?: () => void
  onShow?: () => void
}) => {
  return (
    <>
      <div
        className={`border-x-2 border-primary border-dashed  rounded-md 
                px-4 py-2 flex flex-col justify-center
               items-center relative ${className ?? ''}`}
        style={{ direction: 'initial' }}
      >
        {isOpen ? (
          <>
            <div
              className='absolute -top-36 flex justify-center  items-center flex-col z-[96]
           bg-primaryDefault2'
            >
              <div className='px-2 my-5'>
                <TextBox {...editOption!} />
              </div>
              <div className='flex justify-center items-center px-6 gap-10 w-full py-3 sticky top-full'>
                <Button
                  type='submit'
                  className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-6 !shadow-lg'
                >
                  <Icon icon='rayteb-android-done' />
                </Button>
                <Button
                  onClick={() => onClose?.()}
                  className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-6 !shadow-lg'
                >
                  <Icon icon='rayteb-android-close' />
                </Button>
              </div>
            </div>
            <Icon
              icon='rayteb-arrow-down-b'
              className='absolute -top-9 bottom-0 text-3xl animate-ping h-10 w-10 text-warnDark'
            />
          </>
        ) : (
          ''
        )}
        <span className='absolute -top-3 text-xs text-primary'>{title}</span>
        <span
          onClick={() => onShow?.()}
          className={`text-center text-xs ${isEdit
            ? 'underline decoration-primary decoration-dashed underline-offset-8'
            : ''
            }`}
        >
          {value}
        </span>
      </div>
    </>
  )
}
export default React.memo(DeserveModal)
